import { GLOBAL_REQ_CANCEL } from 'actions/Types';

import ApiClient from '@shoflo/api.v2-client';
import { Subject, from, of } from 'rxjs';
import { takeUntil, mergeMap, catchError } from 'rxjs/operators';

const { hostname, protocol, port } = (window || {}).location;

const apiClient = new ApiClient({
  endpoint: `${protocol}//${hostname}:${port}`,
  proxy: true
});

const cancel$ = new Subject();

export const apiMiddleware = store => next => async action => {
  /**
   * If we get a cancel signal, we tell the cancel$ subject
   */
  if (action.type === GLOBAL_REQ_CANCEL) {
    cancel$.next();
    return next(action);
  }

  /**
   * If it doesn't have a request method, next!
   */
  if (!action.request) {
    return next(action);
  }

  from([action])
    .pipe(
      mergeMap(action =>
        from(action.request(apiClient)).pipe(catchError(error => of({ error })))
      ),
      //If we get any values from cancel$, stop
      takeUntil(cancel$)
    )
    .subscribe(result => {
      if (result.error) {
        store.dispatch({
          type: `${action.type}_FAILURE`,
          payload: result
        });

        return;
      }

      store.dispatch({
        type: `${action.type}_SUCCESS`,
        payload: result
      });
    });

  return next(action);
};

export default apiMiddleware;
